import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { Preferences } from '@capacitor/preferences'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import QrcodeVue from 'qrcode.vue'
import 'vue3-easy-data-table/dist/style.css'

import { IonicVue } from '@ionic/vue'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css'
import '@ionic/vue/css/float-elements.css'
import '@ionic/vue/css/text-alignment.css'
import '@ionic/vue/css/text-transformation.css'
import '@ionic/vue/css/flex-utils.css'
import '@ionic/vue/css/display.css'

/* Theme variables */
import './theme/variables.css'
import './theme/global.css'
import './theme/gestcoop-theme.css'

import { removeFromLocalStorage } from './modules/LocalStorage'
import { showLoader } from '@/modules/Popups'
import './registerServiceWorker'

axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.baseURL = String(process.env.VUE_APP_BACKEND_BASE_URL)
axios.defaults.withCredentials = true

resetUnitInLocalStorage().then(function (response) {
  return true
}).catch(function (e) {
  console.log(e)
})
// userTokens = result

// if (userTokens?.access_token) {
//   axios.defaults.headers.common.Authorization = 'Bearer ' + userTokens.access_token
// }

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, async function (error) {
  if (error.response !== undefined) {
    if (error.response.status === 401) {
      await removeUserTokens()
      await removeFromLocalStorage('user')
      if (error.response.data?.error_code !== undefined) {
        if (error.response.data.error_code === 'cookie_not_found') {
          await removeFromLocalStorage('logged')
          window.location.reload()
        }
      }
    }
    if (error.response.status === 503) {
      // Redirect to maintenance
      await router.push('/maintenance')
    }
  }

  return await Promise.reject(error)
})

// Function that will be called to refresh authorization
const refreshAuthLogic = async function (failedRequest: any): Promise<any> {
  axios.post('refresh')
    .then(async function (response) {
      // console.log('refreshed token')
      // console.log(response)
      // console.log(failedRequest.request)
      // return axios(failedRequest.config)
      // return Promise.reject(failedRequest)
      await showLoader('Caricamento...', 100000)
      window.location.reload()
    }).catch(async function (error) {
      await removeUserTokens()
      await removeFromLocalStorage('logged')
      await removeFromLocalStorage('user')
      await router.push('/login')
      if (error.response.data?.error_code !== undefined) {
        if (error.response.data.error_code === 'cookie_not_found') window.location.reload()
      }
      return await Promise.reject(error)
    })
}

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, refreshAuthLogic)

async function removeUserTokens(): Promise<void> {
  await Preferences.remove({
    key: 'user_token'
  })
}

async function resetUnitInLocalStorage(): Promise<void> {
  await Preferences.remove({
    key: 'worktime_unit_id'
  })
}

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(QrcodeVue)

app.component('EasyDataTable', Vue3EasyDataTable)

router.isReady().then(() => {
  app.mount('#app')
}).catch((e) => {
  console.log(e)
})
